module.exports = __webpack_public_path__ + "static/media/Station1.6afd28e2.png";